<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Filter by</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full" v-model="filterBy">
          <option value="LATEST">latest</option>
          <option value="MOST_POPULAR">most popular</option>
          <option value="TAG">tag</option>
          <option value="CATEGORY">category</option>
          <option value="AUTHOR">author</option>
          <option value="CUSTOM">custom</option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="filterBy == 'CUSTOM'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Posts</span>
      <div class="wf-w-1/2">
        <input
          v-model="postsIds"
          type="text"
          class="wf-w-full wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
        />
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="filterBy == 'TAG'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Tag</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full" v-model="filterId">
          <option v-for="tag in tags" :key="tag.id" :value="tag.id" v-text="tag.name"></option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="filterBy == 'CATEGORY'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Category</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full" v-model="filterId">
          <option v-for="category in categories" :key="category.id" :value="category.id" v-text="category.name"></option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="filterBy == 'AUTHOR'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Author</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full" v-model="filterId">
          <option v-for="author in authors" :key="author.id" :value="author.id" v-text="`${author.first_name} ${author.last_name}`"></option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Sort By</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full" v-model="sortBy">
          <option value="published_at">Date</option>
          <option value="title">Title</option>
          <option value="random">Random</option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="sortBy != 'random'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Order By</span>
      <div class="wf-w-1/2">
        <select class="wf-w-full" v-model="orderBy">
          <option value="ASC">Ascending</option>
          <option value="DESC">Descending</option>
        </select>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="filterBy != 'CUSTOM'">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Quantity</span>
      <div class="wf-w-1/2">
        <input
          v-model="quantity"
          type="text"
          class="wf-w-full wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
        />
      </div>
    </li>
  </div>
</template>

<script>
  import axios from 'axios'
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    data() {
      return {
        posts: [],
        tags: [],
        categories: [],
        authors: [],
      }
    },
    created() {
      this.getTags()
      this.getCategories()
      this.getAuthors()
    },
    computed: {
      postsIds: {
        get() {
          return this.elementContent.filter.filterPostsIds
        },
        set(value) {
          this.addToObject(this.module, {filter: {...this.elementContent.filter, filterPostsIds: value}}, 'content', null, {}, true, this.parentModule)
        }
      },
      sortBy: {
        get() {
          return this.elementContent.filter.filterSortBy
        },
        set(value) {
          this.addToObject(this.module, {filter: {...this.elementContent.filter, filterSortBy: value}}, 'content', null, {}, true, this.parentModule)
        }
      },
      orderBy: {
        get() {
          return this.elementContent.filter.filterOrderBy
        },
        set(value) {
          this.addToObject(this.module, {filter: {...this.elementContent.filter, filterOrderBy: value}}, 'content', null, {}, true, this.parentModule)
        }
      },
      quantity: {
        get() {
          return this.elementContent.filter.filterQuantity
        },
        set(value) {
          this.addToObject(this.module, {filter: {...this.elementContent.filter, filterQuantity: value}}, 'content', null, {}, true, this.parentModule)
        }
      },
      filterId: {
        get() {
          return this.elementContent.filter.filterId
        },
        set(value) {
          this.addToObject(this.module, {filter: {...this.elementContent.filter, filterId: value}}, 'content', null, {}, true, this.parentModule)
        }
      },
      filterBy: {
        get() {
          return this.elementContent.filter.filterBy
        },
        set(value) {
          this.addToObject(this.module, {filter: {...this.elementContent.filter, filterBy: value}}, 'content', null, {}, true, this.parentModule)
          this.filterId = null
        }
      }
    },
    methods: {
      getTags() {
        axios.get(`${process.env.VUE_APP_BACKEND_URL}/editor/api/tags`)
          .then(({data}) => this.tags = data.data.tags)
      },
      getCategories() {
        axios.get(`${process.env.VUE_APP_BACKEND_URL}/editor/api/categories`)
          .then(({data}) => this.categories = data.data.categories)
      },
      getAuthors() {
        axios.get(`${process.env.VUE_APP_BACKEND_URL}/editor/api/authors`)
          .then(({data}) => this.authors = data.data.authors)
      },
    }
  })
</script>